export class FileConst {
  public static readonly KiloByte = 1024;
  public static readonly MegaByte = 1048576;

  public static readonly MaxFileSize = 5 * FileConst.MegaByte;
  public static readonly MaxUploadSize = 20 * FileConst.MegaByte;
  public static readonly MaxUploadCount = 5;

  public static readonly DisplayMaxFileSize = '5MB';
  public static readonly DisplayMaxUploadSize = '20MB';
}
